import React, { useEffect, useState } from "react";
import styles from "./index.module.less";
import { observer } from 'mobx-react-lite';
import hot from "@/assets/images/finance/hot.png";
import gou from "@/assets/icon-svg/finance/gou.svg";
import getProductStatus from "@/components/Pages/Finance/_hook/getProductStatus";
import { Hooks } from "@xt/xtbase";
const {useTranslation} = Hooks;
import SvgIcon from "@xt/SvgIcon";

export default observer(({financialProducts=[],currentProduct=null,onChange=()=>{}}) => {
  const t = useTranslation();

  if(!currentProduct)
    return <></>

  return (
    <div className={styles.durationSelect}>
      {financialProducts.map((item,index)=>{
        var value = 0;
        if(item.productType == "DEMAND_SAVING")
          value = 0;
        else if(item.duration)
          value = item.duration;
        else
          return null;
        return <span className={item.id==currentProduct.id ? styles.selected : ""} style={getProductStatus(item).disabled ? {color:"rgba(255,255,255,0.4)"} : {}} onClick={()=>{
          onChange(item);
        }}>
          {value == 0 ? t("finance.flexible") : value}
          {item.systemTag == "HOT" ? <img className={styles.hot} src={hot} /> : null}
          {item.id==currentProduct.id ? <SvgIcon className={styles.gou} src={gou} style={{color:"var(--primary-color)"}}/> : null}
        </span>
      })}
    </div>
  );
});